import { render, staticRenderFns } from "./MultimediaOriginConfig.vue?vue&type=template&id=036d644b&"
import script from "./MultimediaOriginConfig.vue?vue&type=script&lang=js&"
export * from "./MultimediaOriginConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports